import type { ReactNode } from "react";
import { GlobalFooter } from "./GlobalFooter";
import { cn } from "@/lib/utils";

/**
 * Wrapper for public pages (landing, sign-in, sign-up, entry, etc.).
 * Centred content with a global footer.
 */
export function PublicLayout({
  children,
  centered = true,
  className,
}: {
  children: ReactNode;
  centered?: boolean;
  className?: string;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-[#fafafa]">
      <main
        className={cn(
          "flex-1 px-4 py-10",
          centered && "flex items-center justify-center",
          className,
        )}
      >
        {children}
      </main>
      <GlobalFooter variant="compact" />
    </div>
  );
}
